import { AbstractControl } from '@angular/forms';
import { IPasswordComplexity } from '@models';

type IValidityRegex = {
    [key in keyof IPasswordComplexity['regex']]: boolean;
};

interface IValidity extends IValidityRegex {
    length: number;
}

export const complexity = (pwdComplexity: IPasswordComplexity, required = true) =>
    (c: AbstractControl) => {
        if (
            !required &&
            (c.value == null || c.value === '')
        ) {
            return null;
        }
        const validity: IValidity = Object.keys(pwdComplexity.regex).reduce((prev, currentKeyStr) => {
            const currentKey = currentKeyStr as keyof IPasswordComplexity['regex'];
            if (
                pwdComplexity[currentKey] &&
                (
                    c.value == null ||
                    !pwdComplexity.regex[currentKey].test(c.value)
                )
            ) {
                prev[currentKey] = true;
            }
            return prev;
        }, {} as IValidity);

        if (!c.value || c.value && c.value.trim().length < pwdComplexity.length) {
            validity.length = parseInt(c.value ? c.value.trim().length : 0, 10);
        }

        if (Object.keys(validity).length > 0) {
            return { complexity: validity };
        }

        return null;
    };

